import { Grid } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { getBookingOverview, getProjects, getStatusByYear } from "../../actions/GenomicsResearchAction";
import React, { useEffect, useState } from 'react';
import { useUser } from "../../../providers/user"
// import "./dashboard.css";
import SunilKumar from './sunilkumar.jpeg'
import logo from './bayer.png'
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        card: {
            height: "100%",
            padding: "20px",
        },
        cardContent: {
            textAlign: "center",
        },
        center: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        text: { color: "black" },
    })
);


interface Props {
    getBookingOverview: any;
    bookingoverview: any;
    userDetails: any;
    getProjects: any;
    projects: any;
    getStatusByYear: any;
    fetchStatusByYear: any;
    loading: any
}

const Dashboard: React.FC<Props> = ({
    getBookingOverview,
    bookingoverview,
    getProjects,
    getStatusByYear,
    fetchStatusByYear,
    projects,
    loading,
}) => {
    const classes = useStyles();
    const [showWelcomePage, setShowWelcomePage] = useState(true);
    const user = useUser();

    useEffect(() => {
        getStatusByYear();
    }, []);

    return (
        <>
            <div style={{ width: "100%", margin: "60px auto" }}>
                <div style={{ backgroundColor: "#0b2857", border: "2px solid #0b2857", borderRadius: "10px" }}>
                    <h2 style={{ textAlign: "center", color: "white" }}>MY DASHBOARD</h2>
                </div>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {fetchStatusByYear &&
                        fetchStatusByYear?.results?.length > 0 &&
                        fetchStatusByYear?.results?.map((data: any, index: any) => {
                            return (
                                <div
                                    key={index}
                                    style={{ margin: "10px", width: "calc(45% - 20px)" }}
                                    id="geno"
                                >
                                    <div className="customCard">
                                        <a href={`/dashboard/gnre/samples_count/?year=${data?.year}`} style={{ textDecoration: "none" }}>
                                            <div className="cardContent">
                                                <h3 className="year">{data?.displayYear}</h3>
                                                <div className="counts">
                                                    <p>Total Pending Project: {data?.InProgress}</p>
                                                    <p>Completed Project Count: {data?.Closed}</p>
                                                    <p>Completed Sample Count: {data?.CompletedSamples}</p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            );
                        })}
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state: any) => ({
    bookingoverview: state.GenomicsCAReducer.bookingoverview,
    projects: state.GenomicsCAReducer.projects,
    fetchStatusByYear: state.GenomicsCAReducer.fetchStatusByYear,
    loading: state.GenomicsCAReducer.loading,
});

export default connect(mapStateToProps, {
    getBookingOverview,
    getProjects,
    getStatusByYear,
})(Dashboard);
